import { useTranslation } from 'next-i18next';
import React from 'react';

import { showAlertPrimeurInfosModal } from '@/redux/slices/gui.slice';
import { primeurOnUpdate } from '@/redux/slices/primeur.slice';

import { useAppDispatch, useAppSelector } from '@/redux';
import { getWarnBy, updateWarnBy } from '@/utils/primeurUtils';
import ReturnButton from '@/components/account/ReturnButton';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Form from '@/components/common/form/Form';
import PrimeurPreferencesInputs from '@/components/primeurAlert/PrimeurPreferencesInputs';
import PrimeurUserNoData from '@/components/primeurAlert/PrimeurUserNoData';

import styles from './PrimeurPreferences.module.scss';
import { URLS } from '@/constants/urls';

type PrimeurPreferencesProps = {
  onReturn: () => void,
  isMobileOrTablet?: boolean;
}

export const PrimeurPreferences = ({ onReturn, isMobileOrTablet }: PrimeurPreferencesProps): React.JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { primeurUser } = useAppSelector(({ primeur }) => primeur);

  const defaultValues = {
    email: primeurUser?.email,
    tel: primeurUser?.tel,
    countryPhone: primeurUser?.countryPhone,
    warnBy: getWarnBy(primeurUser)
  };

  const handleSubmit = ({ email, tel, countryPhone, warnBy }) => {
    const [warnByEmail, warnBySms] = updateWarnBy(warnBy);
    dispatch(
      primeurOnUpdate({ t, idPrimeurUser: primeurUser?._id, email, tel, countryPhone, warnByEmail, warnBySms })
    );
  };

  const handleSubscribe = () => {
    dispatch(showAlertPrimeurInfosModal({ products: undefined, name: undefined }));
  };

  return (
    <div className={styles.container} data-rbf="primeur-preferences">
      {isMobileOrTablet &&
        <ReturnButton onClick={() => onReturn()} />
      }
      <h1 className={styles.title}>{t('alert.preferences')}</h1>
      {primeurUser ? (
        <>
          <Form onSubmit={handleSubmit} defaultValues={defaultValues}>
            <PrimeurPreferencesInputs t={t} />
            <CallToActionContainer className={styles.button} id="btn-submit" type="submit">
              {t('btn.save')}
            </CallToActionContainer>
          </Form>
        </>
      ) : (
        <PrimeurUserNoData
          img={URLS.PRIMEUR_SETTING}
          alt="setting"
          text={t('account.subscribe.title')}
          onClick={handleSubscribe}
          labelBtn={t('account.subscribe.btn')}
        />
      )}
    </div>
  );
};

export default PrimeurPreferences;
